const {
    element: { createElement, Fragment, useState },
    i18n: { __ },
    plugins: { registerPlugin },
    editPost: { PluginDocumentSettingPanel, PluginSidebar },
    data: { useSelect, useDispatch },
    components: { RadioControl, TextareaControl, TextControl, ClipboardButton },
} = window.wp;
const anyoneKey = 'docs-share-anyone';
const addressesKey = 'docs-share-email-addresses';

registerPlugin( 'my-document-setting-plugin', {
    render: () => {
        const [ state, setState ] = useState( false );
        const { editPost } = useDispatch( 'core/editor' );
        const { meta, link } = useSelect( ( select ) => {
            const {
                getEditedPostAttribute,
                getCurrentPost,
            } = select( 'core/editor' );
            return {
                meta: getEditedPostAttribute( 'meta' ),
                link: getCurrentPost().link,
            };
        } );

        return <>
            <PluginDocumentSettingPanel
                title={ __( 'Share', 'docs' ) }
                icon="admin-links"
            >
                <RadioControl
                    selected={ meta[ anyoneKey ] || '' }
                    options={ [
                        {
                            label: __( 'Only the author can edit.', 'docs' ),
                            value: '',
                        },
                        {
                            label: __( 'Anyone with the link can edit.', 'docs' ),
                            value: 'anyone',
                        },
                        {
                            label: __( 'Anyone with access to the following email addresses can edit.', 'docs' ),
                            value: 'email',
                        },
                    ] }
                    onChange={ ( value ) => editPost( { meta: {
                        ...meta,
                        [ anyoneKey ]: value,
                    } } ) }
                />
                { meta[ anyoneKey ] === 'email' && <TextareaControl
                    label={ __( 'Comma separated list of email addresses. An email will be sent once the document is saved.', 'docs' ) }
                    value={ meta[ addressesKey ] }
                    onChange={ ( value ) => editPost( { meta: {
                        ...meta,
                        [ addressesKey ]: value,
                    } } ) }
                /> }
                { meta[ anyoneKey ] && <TextControl readOnly value={ link } /> }
                { meta[ anyoneKey ] && <ClipboardButton
                    isLarge
                    text={ link }
                    onCopy={ () => setState( true ) }
                    onFinishCopy={ () => setState( false ) }
                >
                    { state ? __( 'Copied!', 'docs' ) : __( 'Copy Link', 'docs' ) }
                </ClipboardButton> }
            </PluginDocumentSettingPanel>
        </>;
    },
} );
